import { render, staticRenderFns } from "./NoSale.vue?vue&type=template&id=44d6a20c&"
import script from "./NoSale.vue?vue&type=script&lang=js&"
export * from "./NoSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports